import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import useBottomDrawer from './../../bottomDrawer/useBottomDrawer'
import SummaryDrawer from '../SummaryDrawer'
import SummaryDrawerContext from './SummaryDrawerContext'

export type SummaryDrawerContextProviderProps = {
  children?: React.ReactNode
  steps: (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
}

const SummaryDrawerContextProvider = ({ children, steps }: SummaryDrawerContextProviderProps) => {
  const drawer = useBottomDrawer({
    dismissOnSwipeDown: true,
    getSnapPoints: ({ maxHeight, minHeight }) => {
      const collapsedHeight = maxHeight * 0.5
      const headerHeight = 84
      const footerHeight = 47
      const totalContentHeight = minHeight + headerHeight + footerHeight

      return [maxHeight * 0.5, Math.min(Math.max(totalContentHeight, collapsedHeight), maxHeight * 0.9)]
    },
  })

  return (
    <SummaryDrawerContext.Provider value={{ drawer }}>
      {children}
      <SummaryDrawer steps={steps} drawer={drawer} />
    </SummaryDrawerContext.Provider>
  )
}

export default SummaryDrawerContextProvider
